import Api from 'App/api'

const requestTerms = Api.get({
  controller: 'terms',
  action: 'getTermsAndPrivacy',
  skipAuth: true,
})

export const getTerms = async (
  property_id = null,
  cid = null,
  local = 'en_US',
) => {
  const { terms } = await requestTerms({
    language_preference: local.replace('-', '_'),
    property_id,
    cid,
  })
  return terms
}

export const getPrivacyPolicy = async (
  property_id = null,
  cid = null,
  local = 'en_US',
) => {
  const { privacy_policy } = await requestTerms({
    language_preference: local.replace('-', '_'),
    property_id,
    cid,
  })
  return privacy_policy
}
